<template>
  <div class="disputed-orders__stats">
    <div class="stat-card glass-card">
      <div class="stat-value">{{ totalDisputes }}</div>
      <div class="stat-label">Total Disputes</div>
    </div>
    <div class="stat-card glass-card">
      <div class="stat-value">{{ openDisputes }}</div>
      <div class="stat-label">Open</div>
    </div>
    <div class="stat-card glass-card">
      <div class="stat-value">{{ resolvedCount }}</div>
      <div class="stat-label">Resolved</div>
    </div>
    <div class="stat-card glass-card">
      <div class="stat-value">{{ financialDisputes }}</div>
      <div class="stat-label">Financial</div>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'

export default {
  name: 'StatsCards',
  props: {
    disputes: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  setup(props) {
    const totalDisputes = computed(() => props.disputes.length)
    const openDisputes = computed(() => props.disputes.filter(d => d.status === 'open').length)
    const resolvedCount = computed(() => props.disputes.filter(d => d.status === 'resolved').length)
    const financialDisputes = computed(() => 
      props.disputes.filter(d => ['credit_card', 'snap_finance', 'merchant_service'].includes(d.dispute_type)).length
    )
    
    return {
      totalDisputes,
      openDisputes,
      resolvedCount,
      financialDisputes
    }
  }
}
</script>

<style scoped>
.disputed-orders__stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 16px;
  margin-bottom: 24px;
}

.stat-card {
  padding: 20px;
  text-align: center;
  transition: all 0.3s ease;
  cursor: default;
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 16px;
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.stat-value {
  font-size: 34px;
  font-weight: 500;
  color: #1e293b;
  margin-bottom: 8px;
  letter-spacing: -0.5px;
}

.stat-label {
  font-size: 13px;
  color: #64748b;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
</style>


// WEBPACK FOOTER //
// src/components/AdminTools/DisputedOrders/components/StatsCards.vue